import React, { useRef, useLayoutEffect, useState } from 'react';
import px from 'prop-types';

export default function AutoWidth({ as: Component = 'p', children, style, ...props }) {
    const ref = useRef(null);
    const [width, setWidth] = useState(null);

    useLayoutEffect(() => {
        if (!ref.current) return;

        const measure = () => {
            const range = document.createRange();

            range.selectNodeContents(ref.current);
            const rect = range.getBoundingClientRect();
            
            setWidth(rect.width);
        };

        measure(); // Initial measure

        const observer = new ResizeObserver(() => {
            measure();
        });

        observer.observe(ref.current);

        return () => observer.disconnect();
    }, []);

    return (
        <Component
            ref={ref}
            style={{ ...style, width: width != null ? `${width}px` : 'auto' }}
            {...props}
        >
            {children}
        </Component>
    );
}

AutoWidth.propTypes = {
    as: px.string,
    children: px.node,
    style: px.object
};
